import emailjs from '@emailjs/browser';

export const sendEmail = (formData) => {
  // Try to Send Email
  return emailjs.send(
    'ampats2008_gmail_qlsga3w',
    'portfolio-site_1dcna1q',
    formData,
    'QqwqKSsE844ecj0JM'
  );
};
